import { EmailDeliveryState } from 'src/redesign/features/AttendeesSidebar/types';
import { FEATURE_NAME } from 'src/redesign/features/AttendeesSidebar/tabs/EmailDelivery/store/constants';
import { createSlice } from '@reduxjs/toolkit';
import { getEmailDeliveryData } from 'src/redesign/features/AttendeesSidebar/tabs/EmailDelivery/store/actions';

const initialState: EmailDeliveryState = {
  error: null,
  loading: false,
  activities: null,
  summary: null,
};

export const emailDeliverySlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getEmailDeliveryData.fulfilled, (state, action) => {
      state.summary = action.payload.data.summary;
      state.activities = action.payload.data.activities;
      state.loading = false;
      state.error = null;
    });

    builder.addCase(getEmailDeliveryData.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(getEmailDeliveryData.rejected, (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    });
  },
});
